import { PilotReviewReader } from "@/components/email/PilotReviewReader";
import { useWorkspace } from "@/pages/email/CampaignWorkspace";

/** Commercial reading only; Sequence retains common templates and diagnostics. */
export default function PilotReviewTab() {
  const { campaign, slug, access, reload } = useWorkspace();
  if (!campaign.pilot) {
    return <p className="p-6 text-sm text-slate-500">Aucun email de relecture pour cette campagne.</p>;
  }
  return <PilotReviewReader key={campaign.id} record={campaign.pilot} campaignId={campaign.id}
    slug={slug} canEdit={access.can_manage} onSaved={reload} />;
}

// Preserve the existing Sequence import without changing the canvas.
export { DraftSyncPanel } from "@/components/email/DraftSyncPanel";
